export const apiDomain = {
	DEV: 'http://localhost:9002',
	DEMO: 'https://htapi.hotaimotor.com.tw',
	PRODUCTION: 'https://htapi.hotaimotor.com.tw',
}[process.env.NODE_ENV];

export const whostoneApiDomain = {
	DEV: 'http://localhost:9001',
	DEMO: 'https://whostone.svy.do',
	PRODUCTION: 'https://survey.hotaigroup.com.tw/',
}[process.env.NODE_ENV];

export const apiKey = '21fcfc7ee09445bb94098578531b956e';

export default "this is app config";



// WEBPACK FOOTER //
// ./src/js/appConfig.js